export const initFilterInput = {
  search: "",
  page: 1,
  pageSize: 10,
  assigned_employee_id: null
};

export const renderColumns = (handleDetail) => {
  return [
    {
      dataIndex: "date",
      key: "date",
      title: "Tanggal & Waktu",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "No. Telp Nasabah",
      width: "20%",
    },
    {
      dataIndex: "officerName",
      key: "officerName",
      title: "Nama Officer",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
      width: "15%",
      render: (_, record) => (
        <div style={{ color: record.status.color }}>
          {record.status.label}
        </div>
      ),
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <a> <div className="mr-2" onClick={() => handleDetail(record)}>
            <div className="px-4 py-1 bgc-2C465C text-white small rounded">
              Detail
            </div>
          </div></a>
        </div>
      ),
    },
  ];
};